var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-6"},[_c('message-form',{attrs:{"loading":_vm.isLoading},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }